import { FiSettings } from "react-icons/fi";

// helpers
import wording from "@/globals/wording.constants";

//assets
import AllCampaignsIcon from "../icons/AllCampaignsIcon";
import BookingsIcon from "../icons/BookingsIcon";
import GoSearchIcon from "../icons/GoSearchIcon";
import MyMessagesIcon from "../icons/MyMessagesIcon";
import UserProfile from "../icons/UserProfile";
import SupportIcon from "../icons/SupportIcon";


const wordingToUse = wording.header.navigation;

export const HIRER_NAVIGATION_ROUTES_DESK = [
  process.env.NEXT_PUBLIC_APP_WL_CODE === "LOCL"
    ? { label: wordingToUse.desktop.goSearch, route: "/go-search", Icon: GoSearchIcon, isWithSearch: true }
    : { label: wordingToUse.desktop.goSearch, route: "/search-results", Icon: GoSearchIcon, isWithSearch: true },
  { label: wordingToUse.desktop.myCampaigns, route: "/campaigns", Icon: AllCampaignsIcon, isMarginLeft: true },
  { label: wordingToUse.desktop.myBookings, route: "/bookings", Icon: BookingsIcon },
  { label: wordingToUse.desktop.myMessages, route: "/my-messages", Icon: MyMessagesIcon },
].filter(Boolean);

export const HIRER_NAVIGATION_ROUTES = [
  process.env.NEXT_PUBLIC_APP_WL_CODE === "LOCL"
    ? { label: wordingToUse.desktop.goSearch, route: "/go-search", Icon: GoSearchIcon }
    : { label: wordingToUse.desktop.goSearch, route: "/search-results", Icon: GoSearchIcon },
  { label: wordingToUse.desktop.myCampaigns, route: "/campaigns", Icon: AllCampaignsIcon },
  { label: wordingToUse.desktop.myBookings, route: "/bookings", Icon: BookingsIcon },
  { label: wordingToUse.desktop.myMessages, route: "/my-messages", Icon: MyMessagesIcon },
].filter(Boolean);

export const HIRER_ACCOUNT_MOBILE_ROUTES = [
  { label: wordingToUse.mobile.myAccount, route: "/profile", Icon: UserProfile },
  { label: wordingToUse.mobile.mySettings, route: "/settings/organisation-members", Icon: FiSettings },
];

export const BASE_NAVIGATION_ROUTES = [
  { label: "home", route: "/" },
  { label: "lo:live", route: "/lolive" },
  { label: "blog", route: "/blog" },
  { label: "collections", route: "/collections" },
  { label: "list your space", route: "/landlord" }
];

export const LEGAL_PAGES = [
  { label: "Terms of Use", route: "/terms-of-use" },
  { label: "Privacy Policy", route: "/privacy" },
  { label: "Booking Terms", route: "/bookingterms" },
  { label: "Cookie Notice", route: "/cookies" },
];

export const SUPPORT_PAGES = [
  { label: "Support", route: "/support", Icon: SupportIcon },
]
